/* eslint-disable no-console */
import { REQUEST } from 'Stores'
import { ACCOUNT_LIST, INVITE_EMAIL, POST_ACCEPT_INVITE_MEMBER, CHANGE_EMAIL, VERIFY_CHANGE_EMAIL, DELETE_ACCOUNT } from './constants'

export function getAccountList(payload) {
  return {
    type: REQUEST(ACCOUNT_LIST),
    payload
  }
}

export function inviteEmail(payload) {
  return {
    type: REQUEST(INVITE_EMAIL),
    payload
  }
}

export function postAcceptedInviteMember(payload) {
  return {
    type: REQUEST(POST_ACCEPT_INVITE_MEMBER),
    payload
  }
}

export function changeEmail(payload) {
  return {
    type: REQUEST(CHANGE_EMAIL),
    payload
  }
}

export function changeEmailVerifyToken(payload) {
  return {
    type: REQUEST(VERIFY_CHANGE_EMAIL),
    payload
  }
}

export function deleteAccount(payload) {
  return {
    type: REQUEST(DELETE_ACCOUNT),
    payload
  }
}
